import React from 'react';

import checkoutGiftIcon from 'ck-core-client/graphics/checkout/checkout-gift-icon.svg';

import { lang } from './lang';
import { CheckboxBanner, InteractionProps } from '../CheckboxBanner';
import { PALETTE } from 'ck-core-client/source/data/Palette';

export interface Props extends InteractionProps {
	startsWhenRedeemed?: boolean;
}

export const GiftCheckboxBanner: React.SFC<Props> = ({
	checked,
	startsWhenRedeemed,
	handleChange
}) => (
	<CheckboxBanner
		title={lang.TITLE}
		background={PALETTE.red}
		description={lang.DESCRIPTION + (startsWhenRedeemed ? ' ' + lang.STARTS_WHEN_REDEEMED : '')}
		className={'CheckboxBanner--gift'}
		iconUrl={checkoutGiftIcon}
		checked={checked}
		handleChange={handleChange}
	/>
);
